<template>
  <loader :is-loading="isLoadingAttributesObjRef">
    <div v-for="attribute in attributeKeys" :key="attribute">
      <div v-if="!attributesObjRef[attribute].autocomplete" class="d-flex">
        <div class="font-weight-bold">
          {{ generateMessage(`${i18nPath || namespace}.fields.${attribute}`) }}
        </div>
        <v-checkbox
          dense
          v-if="attributesObjRef[attribute].values.length > 2"
          :input-value="isAttributeAllChecked(attribute)"
          @change="toggleAttribute(attribute)"
          class="ma-0 pa-0"
          hide-details
        />
      </div>
      <div v-if="attributesObjRef[attribute].autocomplete" class="mt-4">
        <filter-autocomplete
          :i18nPath="i18nPath"
          :namespace="namespace"
          :attribute="attribute"
          id-field="id"
          name-field="name"
          :labelField="
            generateMessage(`${i18nPath || namespace}.fields.${attribute}`)
          "
          outlined
          shortname-field="shortname"
        />
      </div>
      <div class="d-flex flex-wrap" v-else>
        <div
          v-for="value in attributesObjRef[attribute].values"
          :key="value.id"
        >
          <div class="my-1 d-inline-flex align-top">
            <v-checkbox
              class="ma-0 pa-0"
              hide-details
              dense
              :input-value="isValueChecked(attribute, value.id)"
              @change="handleAttributeValueChange($event, attribute, value.id)"
            />

            <div class="ma-0 pa-0 pr-7">
              <v-chip
                small
                v-if="itemsHasAttributeValueNumber(attribute, value.id)"
                class="ma-0 mr-1"
              >
                {{ itemsHasAttributeValueNumber(attribute, value.id) }}
              </v-chip>
              {{ value.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </loader>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import { mapState } from 'vuex';
import Loader from '@/components/widgets/Loader';
import { isAttributeEqualToRef } from '@/store/baseModule/utils';
import FilterAutocomplete from '@/components/selects/FilterAutocomplete';

export default {
  name: 'CustomFilters',
  components: { Loader, FilterAutocomplete },
  props: {
    namespace: { type: String, required: true },
    i18nPath: { type: String, required: false },
  },
  computed: {
    ...mapState({
      itemsHasAttributeValueNumber(state, getters) {
        return getters[`${this.namespace}/itemsHasAttributeValueNumber`];
      },
      isAttributesObjEqualToRef(state, getters) {
        return getters[`${this.namespace}/isAttributesObjEqualToRef`];
      },
      attributesObjRef(state, getters) {
        return getters[`${this.namespace}/attributesObjRef`];
      },
      attributesObj(state, getters) {
        return getters[`${this.namespace}/attributesObj`];
      },
      attributeKeys(state, getters) {
        return getters[`${this.namespace}/attributeKeys`];
      },
      isLoadingAttributesObjRef(state, getters) {
        return getters[`${this.namespace}/isLoadingAttributesObjRef`];
      },
      isLoadingItems(state, getters) {
        return getters[`${this.namespace}/isLoadingItems`];
      },
    }),
    hasContentSlot() {
      return !!this.$slots.content || !!this.$scopedSlots.content;
    },
  },
  methods: {
    isAttributeEqualToRef,
    isAttributeAllChecked(attribute) {
      return isAttributeEqualToRef({
        attribute,
        attributesObjRef: this.attributesObjRef,
        attributesObj: this.attributesObj,
      });
    },
    toggleAttribute(attribute) {
      return this.$store.dispatch(
        `${this.namespace}/toggleAttribute`,
        attribute
      );
    },
    handleAttributeValueChange(event, attribute, value) {
      const newAttributes = this.attributesObj[attribute]
        ? [...this.attributesObj[attribute].values]
        : [];
      if (event) {
        newAttributes.push(value);
      } else {
        newAttributes.splice(newAttributes.indexOf(value), 1);
      }
      this.$store.dispatch(`${this.namespace}/setFilterAttribute`, {
        attribute,
        values: newAttributes,
        useDelay: true,
      });
    },
    isValueChecked(attribute, id) {
      return (
        this.attributesObj[attribute] &&
        this.attributesObj[attribute].values.includes(id)
      );
    },
    generateMessage,
  },
};
</script>
